import React, { useState } from "react";
import { Helmet } from "react-helmet";
import ListView from "./partials/ListView";
import { useQuery } from "@apollo/react-hooks";
import { LIST, STAFF_LIST, PERIOD_LIST } from "../../queries/rota.query";
import LoadingSpinner from "../../partials/loading";
import auth from "../../providers/Auth.Provider";
import { NavLink } from "react-router-dom";
import CreateRota from "./Create";
import { toast } from "react-toastify";
import { CleanMessage, AppName } from "../../util/app";
import FabButton from "../../partials/Buttons/FabButton";
import { EventEmitter } from "../../event/EventEmitter";
import { EVENT_TARGET } from "../../event/model";

const RotaDuty = () => {
    const { GetAuthenticatedStaff, GetToken } = auth.authProvider;
    const { loading, data } = useQuery(LIST);
    const { loading: pLoading, data: pData, refetch } = useQuery(PERIOD_LIST, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        notifyOnNetworkStatusChange: true,
    });
    const { site } = GetToken() && GetAuthenticatedStaff();
    const { loading: loadingStaff, data: dataStaff } = useQuery(STAFF_LIST, {
        variables: { site: site && site.id, page: 1, limit: 2000 },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });

    const [toggler, setToggler] = useState(false);

    EventEmitter.subscribe(EVENT_TARGET.ROTA, () => refetch());

    return (
        <>
            <Helmet>
                <title> Rota | {AppName}</title>
            </Helmet>

            <div className="row justify-content-center">
                <div className="col-md-12">
                    <NavLink to="/home/clinical-note/ward-summary" className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle btn-default margin-right-10">
                        <i className="material-icons">keyboard_backspace</i> Back Home
                    </NavLink>{" "}
                    <NavLink className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle btn-default" to="./rota/RotaList">
                        <i className="material-icons">list</i> View List
                    </NavLink>
                </div>
                <div className="col-md-11 m-t-20">
                    <LoadingSpinner loading={loading || pLoading || loadingStaff} />
                    {!loading && !toggler && <ListView items={data && data.GetStaffOnRotaDuty.docs} />}
                </div>
                <div className="col-md-11">
                    {toggler && (
                        <CreateRota
                            staff={dataStaff && dataStaff.GetStaffList.docs}
                            periodList={pData.GetRotaDutyPeroids.docs}
                            onCancel={() => {
                                setToggler(false);
                            }}
                        />
                    )}
                </div>
            </div>
            <FabButton title="New Rota" onClick={() => setToggler(true)} />
        </>
    );
};
export default RotaDuty;
